export default {
    data() {
        return {
            paginationInProgress: false,
            pagination: new Pagination()
        }
    },

    watch: {
        // NOTE: v-data-table 小問題
        // 變更 per page 時，會先將 current page 改為 1、再變更 per page（同時觸發兩個 watch）
        "pagination.items": function () {
            this.$nextTick(() => {
                if (!this.paginationInProgress) {
                    this.getList()
                }
            })
        },
        "pagination.page": function () {
            this.$nextTick(() => {
                if (!this.paginationInProgress) {
                    this.getList()
                }
            })
        }
    },
    methods: {
        resetPagination() {
            this.pagination = new Pagination()
        }
    }
}

class Pagination {
    items = 50
    page = 1
    total = 0
}